Ext.define('SA.AcsTable.DefaultViewFactory', {
    singleton: true,

    createDefaultView({model, observable, requestedAttributeIds}) {
        var view = Ext.widget({xtype: 'acs-default-view'}),
            projectView = SA.ProjectView.createOffScreen(view),
            loadMask = view.down('#loadMask'),
            dataMapObservable = new Ext.util.Observable(),
            tableDataObservable = new Ext.util.Observable(),
            folderDataObservable = new Ext.util.Observable(),
            dragObservable = new Ext.util.Observable(),
            toolbar = Ext.widget({xtype: 'acs-table-toolbar', autoShow: true, renderTo: SA.HiddenDom.getContainer()}),
            editionDropdown = toolbar.down('#editionDropdown'),
            viewActionsBtn = toolbar.down('#viewActionsBtn'),
            editViewMenuItem = viewActionsBtn.getMenuItemByItemId('editViewMenuItem'),
            deleteViewMenuItem = viewActionsBtn.getMenuItemByItemId('deleteViewMenuItem'),
            tableSearchField = toolbar.down('#tableSearchField'),
            tableSearchObservable = new Ext.util.Observable(),
            tableSearchController = this.createTableSearchController({
                observable: tableSearchObservable,
                field: tableSearchField,
                popupMargin: {right: 50, bottom: 50},
                getFieldBBox: () => tableSearchField.getBox(),
                getScrollbarSize: () => Ext.getScrollbarSize(),
                getBodySize: () => ({width: document.body.clientWidth, height: document.body.clientHeight})
            }),
            tableData = new SA.AcsTable.TableData({observable: tableDataObservable}),
            folderData = new SA.AcsTable.FolderData({observable: folderDataObservable, requestedAttributeIds}),
            dataMap = new SA.AcsTable.DataMap({observable: dataMapObservable}),
            state = new SA.AcsTable.DefaultViewState({model, projectView, tableData, folderData}),
            grid = SA.view.TableFactory.createTable({
                containerEl: view.down('#tableContainer').el.dom,
                dragObservable,

                cellDelegate: SA.AcsTable.CellDelegate.createCellDelegate({
                    dataMap,
                    topHeader: {cellCls: 'sa-acs-table-top-header-cell', cellContentSize: {width: 180, height: 48}},
                    leftHeader: {cellCls: 'sa-acs-table-left-header-cell', cellContentSize: {height: 36}},
                    body: {cellCls: 'sa-acs-table-body-cell', cellContentSize: {width: 180, height: 36}}
                })
            }),
            controller = new SA.AcsTable.DefaultViewController({
                model,
                projectView,
                loadMask,
                tableData,
                folderData,
                dataMap,
                state,
                grid,
                toolbar,
                tableSearchController
            });

        editionDropdown.setItems(model.getSortedEditions().map(edition => ({text: String(edition), value: edition})));
        editionDropdown.setValue(model.getState().getEdition());

        editionDropdown.on('change', () => controller.onEditionDropdownChange(editionDropdown.getValue()));

        editViewMenuItem.on('click', () => SA.AppController.editView(model));
        deleteViewMenuItem.on('click', () => SA.AppController.deleteView(model));

        observable.on('show', () => controller.onShowView());
        projectView.on('resize', () => controller.onProjectViewResize());
        dragObservable.on('dragend', () => controller.onLocationDragEnd());
        tableSearchObservable.on('select:tableItem', tableId => controller.onTableSearchResultItemClick(tableId));

        model.on('stateResolved', () => controller.onModelStateResolved());
        dataMapObservable.on('results', () => controller.onDataMapResults());
        tableDataObservable.on('results', () => controller.onTableDataResults());
        folderDataObservable.on('results', () => controller.onFolderDataResults());
    },

    createTableSearchController({observable, field, popupMargin, getFieldBBox, getBodySize, getScrollbarSize}) {
        var popupArrowHeight = 7,
            popup = Ext.widget({
                xtype: 'acs-table-search-popup',
                renderTo: document.body,
                alignment: {cmp: field, position: 'tl-bl', offset: [0, popupArrowHeight]}
            }),
            popupSizeGauge = Ext.widget({
                xtype: 'acs-table-search-popup-size-gauge',
                renderTo: document.body,
                popupArrowHeight,
                popupMargin,
                getFieldBBox,
                getBodySize,
                getScrollbarSize
            }),
            input = field.el.dom.querySelector('input'),
            clearBtn = field.el.dom.querySelector('.sa-acs-table-search-field-clear-btn'),
            controller = new SA.AcsTable.TableSearchController({field, input, popup, popupSizeGauge, observable});

        popup.contentCmp = popup.down('acs-table-search-popup-content');
        popup.getPlugin('sa-arrow').setTarget(field);

        popupSizeGauge.contentCmp = popupSizeGauge.down('acs-table-search-popup-content');

        SA.Viewport.on('resize', () => controller.onViewportResize());

        input.addEventListener('focus', () => controller.onInputFocus());
        input.addEventListener('blur', () => controller.onInputBlur());
        input.addEventListener('input', () => controller.onFieldInput());

        input.addEventListener('keydown', ev => {
            if (ev.key === 'Escape') {
                controller.onInputEscapeKeydown();
            }
        });

        document.addEventListener('mousedown', ev => {
            var popupButton = popup.el.dom.contains(ev.target) && ev.target.closest('button');

            if (popupButton) {
                controller.onPopupBtnMouseDown({btn: popupButton});
            }
            else if (clearBtn.contains(ev.target)) {
                controller.onClearBtnMouseDown(ev);
            }
        });

        return controller;
    }
});